/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ events: NonNullable<unknown> }} Letterpreviewsourcedfromonefile5Inputs */

const en_letterpreviewsourcedfromonefile5 = /** @type {(inputs: Letterpreviewsourcedfromonefile5Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Drafted from ${i?.events} timeline events you confirmed and 1 uploaded document.`)
};

const pt_letterpreviewsourcedfromonefile5 = /** @type {(inputs: Letterpreviewsourcedfromonefile5Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Redigida a partir de ${i?.events} eventos da cronologia que confirmou e 1 documento carregado.`)
};

/**
* | output |
* | --- |
* | "Drafted from {events} timeline events you confirmed and 1 uploaded document." |
*
* @param {Letterpreviewsourcedfromonefile5Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewsourcedfromonefile5 = /** @type {((inputs: Letterpreviewsourcedfromonefile5Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewsourcedfromonefile5Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewsourcedfromonefile5(inputs)
	return pt_letterpreviewsourcedfromonefile5(inputs)
});
export { letterpreviewsourcedfromonefile5 as "letterPreviewSourcedFromOneFile" }